import styled, { css } from 'styled-components';
import { color, typography, space } from 'styled-system';
import IconStyles from '../base/iconStyles';

const InfoboxStyles = styled.div`
  ${space}
  ${typography}
  ${color}

  box-shadow: ${props => props.theme.boxShadow};
  padding: ${props => parseFloat(props.theme.space[4]) / 2}rem;
  position: relative;

  ${props =>
    props.backgroundColor === undefined &&
    css`
      background-color: ${props.theme.colors.yellowLight};
    `};

  ${props =>
    props.iconType !== undefined &&
    css`
      padding-left: ${parseFloat(props.theme.space[4]) * 1.5}rem;

      @media screen and (max-width: 1023px) {
        padding-left: 40px;
      }

      ${IconStyles} {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: ${props.theme.space[3]};

        @media screen and (max-width: 1023px) {
          left: ${props.theme.space[2]};
        }
      }
    `};
`;

export default InfoboxStyles;
